import { OrderDetailsService } from './../shared/services/order-details/order-details.service';
import { LoginService } from './../shared/services/login/login.service';
import { AutofillEligibilityService } from '../shared/services/autofill-eligibility/autofill-eligibility.service';
import { localConsole } from '../shared/utils/local-console';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/order-details/order-details.service";
import * as i2 from "../shared/services/autofill-eligibility/autofill-eligibility.service";
import * as i3 from "../shared/services/login/login.service";
export class AutofillEligibilityResolver {
    constructor(_order, _autofillEligibilty, _auth) {
        this._order = _order;
        this._autofillEligibilty = _autofillEligibilty;
        this._auth = _auth;
    }
    resolve(route, state) {
        const user = this._auth.userData || {};
        // 06/04/2020: added isApprovalRequired check on autofillEligibility check
        // TODO: refactor checks for eligiblity checks
        if (user.authenticated && user.rxTied && this._order.dynamicDashboard &&
            this._autofillEligibilty.autofillEnabled && this._order.asyncOrderDetails) {
            this._order.asyncOrderDetails.subscribe(data => {
                if (this._order.approvalRequired) {
                    this.setEligiblityDefaults(false);
                }
                if (this._order.isAutoFillEnrolled) {
                    // If already autofill enrolled, use eligibility service
                    // subject to notify header and tabs to show/hide necessary
                    // features
                    this.setEligiblityDefaults(this._order.isAutoFillEnrolled);
                }
                const currentBox = this._order.currentBox();
                if (currentBox && !this._order.isAutoFillEnrolled && this._order.shouldCheckEligibility(currentBox)) {
                    if (!this._autofillEligibilty.pendingDetermination) {
                        return this._autofillEligibilty.getAutofillEligibility(currentBox, user).subscribe(res => {
                            return res;
                        }, err => err);
                    }
                }
            }, err => {
                localConsole.log(err);
                return err;
            });
        }
        else {
            // set default false if all conditions are failed
            this.setEligiblityDefaults(false);
        }
        return true;
    }
    setEligiblityDefaults(autofillEnrolled) {
        const status = {
            autofillEnrolled: autofillEnrolled,
            autofillEligible: false
        };
        this._autofillEligibilty.asyncSDEligibility.next(status);
        return status;
    }
}
AutofillEligibilityResolver.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AutofillEligibilityResolver_Factory() { return new AutofillEligibilityResolver(i0.ɵɵinject(i1.OrderDetailsService), i0.ɵɵinject(i2.AutofillEligibilityService), i0.ɵɵinject(i3.LoginService)); }, token: AutofillEligibilityResolver, providedIn: "root" });
